import { TrackParms } from 'types';

declare const window: any;

const GTrack = {
  pv(args: TrackParms) {
    if (window.gTrack?.Omega) {
      window.gTrack.pv(args);
    }
  },
  sw(args: TrackParms) {
    if (window.gTrack?.Omega) {
      window.gTrack.sw(args);
    }
  },
  ck(args: TrackParms) {
    if (window.gTrack?.Omega) {
      window.gTrack.ck(args);
    }
  },
};

export default GTrack;
